import { render, staticRenderFns } from "./editRecord.vue?vue&type=template&id=cb5faffe&scoped=true&"
import script from "./editRecord.vue?vue&type=script&lang=js&"
export * from "./editRecord.vue?vue&type=script&lang=js&"
import style0 from "./editRecord.vue?vue&type=style&index=0&id=cb5faffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5faffe",
  null
  
)

export default component.exports